<template>
  <div class="bee_task_base_layout" >


    <div class="dialog_app_layout">
      <div class="icon_app_close_empty"></div>
      <div class="icon_app_top_img"></div>

      <div class="icon_app_close_empty"></div>
    </div>


    <div class="bee_content_main">


      <div class="bar_layout">

        <div class="icon_app_close_img" @click="doClose()" ></div>
        <tabView @tab="tabCheack"></tabView>
        <div class="icon_app_close_empty"></div>
        <!-- <tab></tab> -->


        <!-- <div class="sign_css" @click="doCheckin()" v-if="isTodaySign">
          <div>Completed</div>
        </div>

        <div class="sign_css" @click="doCheckin()" v-else>
          <div class="sign_logo" />
          <div>Check-in</div>
        </div> -->

      </div>



      <div v-show="false">
        已登录

        <div class="h_layout">
          <div @click="onBeeLogin" class="sendBtn">Bee登录</div>
        </div>

        <div class="net_layout" v-if="netTitle">{{ netTitle }}</div>

        <div class="h_layout">
          <div @click="onTwitterLogin" class="sendBtn">Twitter 授权</div>
        </div>

        <div class="h_layout">
          <div @click="onTgLogin" class="sendBtn">TG 授权</div>
        </div>

        <div class="h_layout">
          <div @click="onDiscord" class="sendBtn">Discord 授权</div>
        </div>

        <div class="h_layout">
          <div @click="onTwitterFrieBase" class="sendBtn">去签到</div>
        </div>

        <div class="h_layout">
          <div @click="gotoNet" class="sendBtn">下一页</div>
        </div>

        <!-- <vue-telegram-login mode="callback" @loaded='telegramLoadedCallbackFunc' telegram-login="BeeNetwork_Bot"
      @callback="tgCallbackFunction" /> -->

        <div id="telegram_layout">

        </div>




        <div class="pageLayout">

          <div class="sendBtn" style="margin-right: 16px;" @click="closeDialog">关闭</div>
          <div class="sendBtn" style="margin-left: 16px;" @click="getUserLoginInfo">获取登录状态</div>
        </div>

      </div>

      <div v-if="index_tab == 0" class="tab-content">
        <taskView :opacityNumber="opacityLayoutNumber" :isLoad="isUserLoginStatus" :xpCheckInToday="xpTodayNumber"
          :xpNumber="xpNumber" :taskList="taskList" :checkinList="checkinList" :isTodaySign="isTodaySign"
          @checkInClick="doCheckin">
        </taskView>
      </div>

      <div v-else class="tab-content">
        <rankView :userData="userData" :topU3="topU3" :topU2="topU2" :topU1="topU1" :myself="mySelfOrder"
         :w_userData="w_userData" :wtopU3="wtopU3" :wtopU2="wtopU2" :wtopU1="wtopU1" :w_myself="w_mySelfOrder"
         :o_userData="o_userData" :otopU3="otopU3" :otopU2="otopU2" :otopU1="otopU1" :o_myself="o_mySelfOrder"
        >
        </rankView>
      </div>


    </div>
  </div>

  <div>

  </div>

  <signDialog ref="signDialog" :taskList="checkinList" :isTodaySign="isTodaySign"></signDialog>

  <successDialog ref="successDialog"></successDialog>
</template>

<script>
import {
  baseUrl, test_twitter_auth_url, twitter_redirect_uri, discord_auth_url, api_base_url, todayNmf
} from "../util/mock.js"
import Toast from "../components/message.js";
import signDialog from "./dialog/signDialog.vue"
import successDialog from "./dialog/successDialog.vue"

import tabView from '../view/tab/index.vue'
import taskView from '../view/task/index.vue'
// import rankView from '../view/rank/index.vue'
import rankView from '../view/rank/rankView.vue'
import { addEmit, resultEmitEvent } from "../util/event";
import { AccountStore } from "../util/Account.js";
import icon_sign from '../assets/icon_sign.png';
import { getClientInfo } from "../util/beeSdk.js";

export default {
  name: 'HomeView',

  components: { signDialog, tabView, taskView, rankView, successDialog },

  props: {
    title: String,
    msg: String,
  },
  data() {
    return {
      timeValue: '',
      userList: [],
      isUserLoginStatus: false,
      netTitle: "",
      postContent: "",
      input_post: "",
      chat_gpt: "",
      chat_case: "",
      selectedValue: "",
      userPage: 1,
      tgJs: "",
      index_tab: 0,
      rankData: {},
      userData: [],
      w_userData: [],
      o_userData: [],
      topU1: {},
      topU2: {},
      topU3: {},
      wtopU1: {},
      wtopU2: {},
      wtopU3: {},
      otopU1: {},
      otopU2: {},
      otopU3: {},

      taskList: [],
      checkinList: [],
      mySelfOrder: {},
      w_mySelfOrder: {},
      o_mySelfOrder: {},
      signIcon: "",
      isTodaySign: false,
      xpNumber: 0,
      xpTodayNumber: 0,
      testTaskList: [
        // {
        //   "taskId": 152,
        //   "title": "Daily Task Bee.com",
        //   "content": "Daily Task Cats",
        //   "url": "https://www.bee.com/sites/17341.html",
        //   "xp": 10.00,
        //   "logoUrl": "https://static.bee.com/images/7dd720bf83fc9c55a7f8003cdcfd7247-0000011740.png",
        //   "taskType": "DailyTask",
        //   "participate": true,
        //   "verified": true,
        //   "claimed": true,
        //   "createTime": 1728528379700,
        //   "updateTime": 1728528379700
        // },
        // {
        //   "taskId": 104,
        //   "title": "Once Task Twitter",
        //   "content": "Once Task Twitter",
        //   "url": "https://twitter.com/beenetworkintl",
        //   "xp": 20.00,
        //   "logoUrl": "https://static.bee.com/images/71171558c6597e9310d70c6b65f8ede5-0000011866.png",
        //   "taskType": "OnceTask",
        //   "participate": true,
        //   "verified": true,
        //   "claimed": true,
        //   "createTime": 1728463246202,
        //   "updateTime": 1728463246202
        // },
        // {
        //   "taskId": 103,
        //   "title": "Must Task DC",
        //   "content": "Must Task DC",
        //   "url": "https://discord.com/invite/zPkYTHfyrZ",
        //   "xp": 20.00,
        //   "logoUrl": "https://static.bee.com/images/71171558c6597e9310d70c6b65f8ede5-0000011866.png",
        //   "taskType": "MustTask",
        //   "participate": false,
        //   "verified": false,
        //   "claimed": false,
        //   "createTime": 1728461893080,
        //   "updateTime": 1728461893080
        // },
        // {
        //   "taskId": 102,
        //   "title": "Daily Task TG",
        //   "content": "Daily Task TG",
        //   "url": "https://t.me/+Hvaxi0mydVQ2ZjA1",
        //   "xp": 20.00,
        //   "logoUrl": "https://static.bee.com/images/71171558c6597e9310d70c6b65f8ede5-0000011866.png",
        //   "taskType": "DailyTask",
        //   "participate": false,
        //   "verified": false,
        //   "claimed": false,
        //   "createTime": 1728460437620,
        //   "updateTime": 1728461766102
        // },
        // {
        //   "taskId": 53,
        //   "title": "View Tweet",
        //   "content": "View the official Bee Network Twitter and complete tasks to receive rewards.",
        //   "url": "https://x.com/Beenetworkintl/status/1838055342514798843",
        //   "xp": 10.00,
        //   "logoUrl": "https://static.bee.com/images/7dd720bf83fc9c55a7f8003cdcfd7247-0000011740.png",
        //   "taskType": "OnceTask",
        //   "participate": false,
        //   "verified": false,
        //   "claimed": false,
        //   "createTime": 1728374487871,
        //   "updateTime": 1728374487871
        // },
        // {
        //   "taskId": 52,
        //   "title": "Follow Bee Network",
        //   "content": "Follow the official Bee Network Twitter and complete tasks to receive rewards.",
        //   "url": "https://x.com/Beenetworkintl",
        //   "xp": 10.00,
        //   "logoUrl": "https://static.bee.com/images/7dd720bf83fc9c55a7f8003cdcfd7247-0000011740.png",
        //   "taskType": "MustTask",
        //   "participate": false,
        //   "verified": true,
        //   "claimed": true,
        //   "createTime": 1728372063351,
        //   "updateTime": 1728372308696
        // },
        // {
        //   "taskId": 5,
        //   "title": "Telegram",
        //   "content": "bind tg",
        //   "url": "https://www.bee.com",
        //   "xp": 20.00,
        //   "logoUrl": "https://static.bee.com/images/21224341b97301d088b46a273aa1be98-0000001923.png",
        //   "taskType": "OnceTask",
        //   "participate": false,
        //   "verified": true,
        //   "claimed": false,
        //   "createTime": 1727420697822,
        //   "updateTime": 1727420697822
        // },
        // {
        //   "taskId": 4,
        //   "title": "Discord",
        //   "content": "bind dc",
        //   "url": "https://www.bee.com",
        //   "xp": 20.00,
        //   "logoUrl": "https://static.bee.com/images/6fc971a1dc28463adfc37e9fd42c313f-0000007375.png",
        //   "taskType": "OnceTask",
        //   "participate": false,
        //   "verified": false,
        //   "claimed": false,
        //   "createTime": 1727420669146,
        //   "updateTime": 1727420669147
        // }
      ],
      difference_number: 0,
      opacityLayoutNumber: 0.5,
      todaySignXp: 0,
    }
  },

  watch: {
    // 监听 selectedValue 的变化，以便在值改变时执行某些操作
    selectedValue(newValue) {
      // console.log(newValue);
      this.setSelectValue();
    }
  },

  methods: {
    async tabCheack(v) {
      this.index_tab = v;
      if (v == 1) {
        this.getRankData();
      } else {
        await AccountStore.fetchUserInfo();
        this.xpNumber = AccountStore.accountBindInfo.xp;
      }
    },


    setSelectValue() {
      for (var i = 0; i < this.userList.length; i++) {
        this.userList[i].comment = this.selectedValue;
      }
    },

    async onBeeLogin() {
      this.beeLogin();
    },

    async init() {
      // const userIsLogin = await fetch(`${baseUrl()}/wp-json/beeTask/v1/getBeeUserIsLogin`)
      // let data = await userIsLogin.json()
      // console.log(data);
    },

    async beeLogin() {
      const userIsLogin = await fetch(`${baseUrl()}/wp-json/beeTask/v1/setBeeUserLogin`)
      let data = await userIsLogin.json()
      // console.log(data);
      window.location.href = data.url;
    },

    onTwitterLogin() {
      // Toast("提交成功", "success");
      window.location.href = test_twitter_auth_url;
    },
    onDiscord() {
      window.location.href = discord_auth_url;
    },


    onTgLogin() {
      var telegram_layout = document.getElementById('telegram_layout')
      var script = document.createElement("script");
      script.src = this.tgJs;
      // script.setAttribute('data-telegram-login', 'beetasktestbot')
      script.setAttribute('data-telegram-login', 'beehive3bot')
      script.setAttribute('data-size', 'large')
      script.setAttribute('data-onauth', 'onTelegramAuth(user)')
      script.setAttribute('data-request-access', 'write')
      script.async = true
      telegram_layout.appendChild(script);
      this.scriptCount = true
      // Toast("提交成功", "success");
    },


    async getNextPage() {
      this.init();
    },

    closeDialog() {
      let bee_task_base_layout = document.getElementById("bee_task");
      bee_task_base_layout.style.display = "none";
    },

    base64Encode(str) {
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
    },


    async getUserLoginInfo() {
      await AccountStore.fetchUserInfo();
      this.isUserLoginStatus = AccountStore.isUserLoginStatus;
      try {
        this.xpNumber = AccountStore.accountBindInfo.xp;
        //console.log(AccountStore.accountBindInfo)
      } catch {

      }

      if (this.isUserLoginStatus) {
        this.opacityLayoutNumber = 1;
      } else {
        this.opacityLayoutNumber = 0.5;
      }
      // this.getAppInfo();
      this.get_wp_task();
      this.getRankData();
      let bee_task_base_layout = document.getElementById("bee_task");

      // console.log(bee_task_base_layout.style.display + "====== bee_task_base_layout.style.display");
      const today = todayNmf();
      let isBaseShow = localStorage.getItem(today);
      console.log(isBaseShow + "===isBaseShow===" + today);
      if (isBaseShow) {
      } else {
        // console.log(isBaseShow + "===isBaseShow===" + today);
        // bee_task_base_layout.style.display = "flex";
        localStorage.setItem(today, true);
      }

    },


    tgCallbackFunction(user) {
      // console.log(user);
    },

    telegramLoadedCallbackFunc() {
      // console.log("telegramLoadedCallbackFunc");
    },

    getQueryString(url) {
      let ItemArr = [];
      let ItemObj = {};
      url
        .substring(url.lastIndexOf("?") + 1, url.length)
        .split("&")
        .map((item) => {
          ItemArr.push(item.split("="));
        });
      ItemArr.map((item) => {
        ItemObj[item[0]] = item[1];
      });
      return ItemObj;
    },

    onTwitterFrieBase() {
      this.getRequestToken();
    },

    getTimestamp() {
      var timestamp = new Date().getTime();
      return timestamp;
    },


    async getAjaxJsPath() {
     

    },

    onHandlerWindowMessageTelegramAuth(msg) {
      // console.log("onHandlerWindowMessageTelegramAuth")
      // console.log(msg.data)
      this.onTelegramAuth(msg.data);
    },

    gotoNet() {
      this.$router.push("/set");
    },
    async bindTwitter(code, redirectURI) {
      var e_mail = "";
    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      const user = JSON.parse(userData);
     e_mail = user.user.email;
    }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_bindTwitter',
          code: code,
          redirectURI: encodeURIComponent(redirectURI),
          _wpnonce: "wp_nonce",
          userInfo: e_mail,
        }),
      };
      const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json();
      let wp_data = data.data.data;
      try {
        let json = JSON.parse(wp_data);
        if (json.code == 200) {
          // console.log(data);
          await AccountStore.fetchUserInfo();
          let view = document.getElementById("bee_task");
         // view.style.display = "flex";
        } else {
          Toast(json.message, "error");
        }
      } catch (error) {
        Toast(wp_data, "error");
      }
      // console.log(AccountStore.accountBindInfo)
    },


    onTelegramAuth(tgData) {
      // console.log("onTelegramAuth==" + tgData)
      if (tgData != null && tgData != undefined) {
        try {
          const tg = JSON.parse(tgData);
          this.bindTg(tg.auth_data);
        } catch (error) {

        }

      }
    },

    async bindTg(tg) {
      // console.log("bindTg==" + tg)
      var e_mail = "";
    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      const user = JSON.parse(userData);
     e_mail = user.user.email;
    }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_bindTG',
          id: tg.id,
          first_name: tg.first_name,
          last_name: tg.last_name,
          photo_url: tg.photo_url,
          auth_date: tg.auth_date,
          hash: tg.hash,
          _wpnonce: "wp_nonce",
          userInfo: e_mail,
        }),
      };
      const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json();
      let wp_data = data.data.data;
      try {
        let json = JSON.parse(wp_data);
        if (json.code == 200) {
          // console.log(data);
          await AccountStore.fetchUserInfo();
          let view = document.getElementById("bee_task");
          //view.style.display = "flex";
        } else {
          Toast(json.message, "error");
        }
      } catch (error) {
        Toast(wp_data, "error");
      }
    },


    async getAppTasks() {
      var url = api_base_url() + "/uni-task/app/tasks?userId=0";
      // console.log(url);
      const data = await fetch(url)
      this.postContent = await data.json()
      // console.log(this.postContent)
    },

    async doTask() {
      var url = api_base_url() + "/uni-task/app/doTask?userId=0";
      // console.log(url);
      const data = await fetch(url)
      this.postContent = await data.json()
      // console.log(this.postContent)
    },
    async bindDC(dcCode, redirectURI) {
      var e_mail = "";
    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      const user = JSON.parse(userData);
     e_mail = user.user.email;
    }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_bindDC',
          code: dcCode,
          redirectURI: encodeURIComponent(redirectURI),
          _wpnonce: "wp_nonce",
          userInfo: e_mail,
        }),
      };
      const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json();
      // console.log(data);
      let wp_data = data.data.data;
      try {
        let json = JSON.parse(wp_data);
        if (json.code == 200) {
          // console.log(data);
          await AccountStore.fetchUserInfo();
          let view = document.getElementById("bee_task");
        //  view.style.display = "flex";
        } else {
          Toast(json.message, "error");
        }
      } catch (error) {
        Toast(wp_data, "error");
      }
    },
    async verifyTask() {
      var url = api_base_url() + "/uni-task/app/verifyTask?userId=0";
      // console.log(url);
      const data = await fetch(url)
      this.postContent = await data.json()
      // console.log(this.postContent)
    },
    doClose() {
      // this.$refs.successDialog.showDialog(20);
      let view = document.getElementById("bee_task");
      view.style.display = "none";
    },

    async getRankData() {
       var e_mail = "";
    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      const user = JSON.parse(userData);
     e_mail = user.user.email;
    }

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_getRankInfo',
           userInfo: e_mail,
        }),
      };

      const userInfoData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
      // console.log(userInfoData);
      let r_data = await userInfoData.json()
      let wp_data = r_data.data.data;
      this.rankData = wp_data;
      // this.topAll = wp_data.topAll;
      // this.topWeek = wp_data.topWeek;
      // this.topDay = wp_data.topDay;

      // this.mySelfOrder = wp_data.dayMyOrder;
      // let list = wp_data.topDay;
      // this.setTopUser(list)
      this.setTopData(wp_data);
    },
    setTopData(wp_data) {
      let ulistData = wp_data.topDay;
      try {
        this.topU1 = ulistData[0];
        this.topU2 = ulistData[1];
        this.topU3 = ulistData[2];
        this.userData = ulistData;
      } catch (error) {
        
      }
      this.mySelfOrder = wp_data.dayMyOrder;

      let topWeekData = wp_data.topWeek;
      try {
        this.wtopU1 = topWeekData[0];
        this.wtopU2 = topWeekData[1];
        this.wtopU3 = topWeekData[2];
        this.w_userData = topWeekData;
      } catch (error) {
        
      }

      let allMyOrderData = wp_data.topAll;
      try {
        this.otopU1 = allMyOrderData[0];
        this.otopU2 = allMyOrderData[1];
        this.otopU3 = allMyOrderData[2];
        this.o_userData = allMyOrderData;
      } catch (error) {
        
      }
      this.w_mySelfOrder = wp_data.weekMyOrder;
      this.o_mySelfOrder = wp_data.allMyOrder;
    },



    setTopUser(ulistData) {
      if (ulistData.length < 2) {
        return;
      }
      try {
        this.topU1 = ulistData[0];
        this.topU2 = ulistData[1];
        this.topU3 = ulistData[2];
        // ulistData.shift();
        // ulistData.shift();
        // ulistData.shift();
        this.userData = ulistData;
      } catch (error) {
        // console.log("=======" + error);
      }
    },

    rankCheckTab(index) {
      // console.log(index + "=====")
      let clist = [];
      if (index == 0) {
        clist = this.rankData.topDay;
        this.mySelfOrder = this.rankData.dayMyOrder;
      } else if (index == 1) {
        clist = this.rankData.topWeek;
        this.mySelfOrder = this.rankData.weekMyOrder;
      } else {
        clist = this.rankData.topAll;
        this.mySelfOrder = this.rankData.allMyOrder;
      }
      // console.log(clist.length);

      this.setTopUser(clist)
    },


    async get_wp_task() {
                  var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_getTasks',
          userId: "0",
          userInfo: e_mail,
        }),
      };

      const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
      let r_data = await ajaxData.json();
      let wp_data = r_data.data.data;
      let json = JSON.parse(wp_data);
      // console.log(json.data)
      let taskData = json.data;

      this.formatTask(taskData);
      // console.log(wp_data)
    },

    formatTask(taskData) {

      const mNetInfoList = [];
      var testv0 = [];
      var testv1 = [];
      var testv2 = [];
      var testv3 = [];
      var av0 = {};
      var av1 = {};
      var av2 = {};
      var av3 = {};
      // testv0.push({
      //     "taskId": 4,
      //     "title": "Discord",
      //     "content": "bind dc",
      //     "url": "https://www.bee.com",
      //     "xp": 20.00,
      //     "logoUrl": "https://static.bee.com/images/6fc971a1dc28463adfc37e9fd42c313f-0000007375.png",
      //     "taskType": "OnceTask",
      //     "participate": false,
      //     "verified": false,
      //     "claimed": false,
      //     "createTime": 1727420669146,
      //     "updateTime": 1727420669147
      // });
      taskData.sort(function (a, b) {
        return a.count - b.count;
      });
      for (const element of taskData) {
        let taskType = element.taskType;

        if (taskType === "DailyTask") {
          if (element.verified == false || element.claimed == false) {
            testv0.unshift(element);
          } else {
            testv0.push(element);
          }
          av0["name"] = "Daily Task";
        }
        if (taskType === "OnceTask") {
          av1["name"] = "Once Task";
          if (element.verified == false || element.claimed == false) {
            testv1.unshift(element);
          } else {
            testv1.push(element);
          }
        }
        if (taskType === "MustTask") {
          av2["name"] = "Must Task";
          if (element.verified == false || element.claimed == false) {
            testv2.unshift(element);
          } else {
            testv2.push(element);
          }
        }

        if (taskType === "ReferralTask") {
          if (element.verified == true && element.claimed == true) {
            // testv3.unshift(element);
          } else {
            if (testv3.length < 2) {
              testv3.push(element);
            }

          }

          av3["name"] = "Referral";
        }

      }

      av0["list"] = testv0;
      av1["list"] = testv1;
      av2["list"] = testv2;
      av3["list"] = testv3;
      mNetInfoList.push(av0);
      mNetInfoList.push(av3);
      mNetInfoList.push(av2);
      mNetInfoList.push(av1);
      this.taskList = mNetInfoList;
    },

    async getCheckinTasks() {
                  var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_checkinData',
          userInfo: e_mail,
        }),
      };

      const userInfoData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
      // console.log(userInfoData);
      let r_data = await userInfoData.json()
      let wp_data = r_data.data.data;
      let json = JSON.parse(wp_data);
      // console.log(json.data)
      this.checkinList = json.data;
      let total = 0;
      let allDay = 0;
      let oxp = 0;
      for (var i = 0; i < this.checkinList.length; i++) {
        let item = this.checkinList[i];
        if (item.checked == true) {
          total = total + item.xp;
          allDay = allDay + 1;
          oxp = item.xp;
        }
        if (item.isToday && item.checked) {
          this.isTodaySign = true;
        }
      }

      this.$refs.signDialog.showDialog(oxp, total, allDay);
      // addEmit("dialog_show", total);

      this.getRankData();



    },

    async doCheckin() {

      this.getCheckinTasks();
    },

    async initCheckinTasks() {
                        var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_checkinData',
          userInfo: e_mail,
        }),
      };

      const userInfoData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
      // console.log(userInfoData);
      let r_data = await userInfoData.json()
      let wp_data = r_data.data.data;
      let json = JSON.parse(wp_data);
      // console.log(json.data)
      this.checkinList = json.data;
      let total = 0;
      let allDay = 0;
      let oxp = 0;
      for (var i = 0; i < this.checkinList.length; i++) {
        let item = this.checkinList[i];
        if (item.checked == true) {
          total = total + item.xp;
          allDay = allDay + 1;
          oxp = item.xp;
        }
        if (item.isToday && item.checked) {
          this.isTodaySign = true;
        }
        if (item.isToday) {
          this.xpTodayNumber = item.xp;
        }
      }
      this.todaySignXp = oxp;
      return oxp;
      // AccountStore.fetchUserInfo();
      // this.xpNumber = AccountStore.accountBindInfo.xp;
      // console.log(AccountStore.accountBindInfo)
    },

    async animXpNumber() {
      let that = this;
      await AccountStore.fetchUserInfo();
      let getXp = AccountStore.accountBindInfo.xp;

      console.log("getXp=" + getXp);

      // // await AccountStore.fetchUserInfo();
      // let getXp = 1000;

      if (getXp != this.xpNumber && getXp > this.xpNumber) {
        that.xpNumber = that.xpNumber + 1;

        let spNumber = getXp - that.xpNumber;

        if (spNumber > 30) {
          this.xpNumber = this.xpNumber + (spNumber - 30);
        }
        if (spNumber > 20) {
          this.jumpIntervalId_20(getXp);
        } else if (spNumber > 10) {
          this.jumpIntervalId_10(getXp);
        } else if (spNumber > 2) {
          this.jumpIntervalId_5(getXp);
        } else {
          this.jumpIntervalId_1(getXp);
        }


      }
    },

    jumpIntervalId_20(totalXp) {
      let that = this;
      let intervalId = setInterval(function () {
        let spNumber = totalXp - that.xpNumber;
        that.xpNumber = that.xpNumber + 1;
        if (spNumber <= 10) {
          clearInterval(intervalId);
          that.jumpIntervalId_10(totalXp);
        }
      }, 50);
    },

    jumpIntervalId_10(totalXp) {
      let that = this;
      let intervalId = setInterval(function () {
        // console.log("====<10")
        let spNumber = totalXp - that.xpNumber;
        that.xpNumber = that.xpNumber + 1;
        if (spNumber <= 5) {
          clearInterval(intervalId);
          that.jumpIntervalId_5(totalXp);
        }
      }, 100);
    },

    jumpIntervalId_5(totalXp) {
      let that = this;
      let intervalId = setInterval(function () {
        that.xpNumber = that.xpNumber + 1;
        let spNumber = totalXp - that.xpNumber;
        if (spNumber <= 1) {
          clearInterval(intervalId);
          that.jumpIntervalId_1(totalXp);
        }

      }, 200);
    },
    jumpIntervalId_1(totalXp) {
      let that = this;
      let intervalId = setInterval(function () {
        that.xpNumber = that.xpNumber + 1;
        if (that.xpNumber >= totalXp) {
          that.xpNumber = totalXp;
          clearInterval(intervalId);
        }
      }, 700);
    },

    checkViewDisplay() {
      let that = this;
      let intervalId = setInterval(function () {
        let bee_task_base_layout = document.getElementById("bee_task");

        if (bee_task_base_layout.style.display == "flex") {
          clearInterval(intervalId);
          that.resUi();
        }
      }, 1000);
    },

    async resUi() {
      await this.init();
      await this.getUserLoginInfo();
      await this.getAjaxJsPath();
      this.initCheckinTasks();
    },

    async showSignSuccessDialog() {
      await this.initCheckinTasks();
      this.$refs.successDialog.showDialog(this.todaySignXp);
    },
    async getBeeClientInfo() {
      let info = await getClientInfo();
      if (info != null && info.channel == "appstore") {
        let google_apk = document.getElementById("google_apk");
        google_apk.style.display = "none";
        let android_apk = document.getElementById("android_apk");
        android_apk.style.display = "none";
        let bee_link_recharge = document.getElementById("bee_link_recharge");
        bee_link_recharge.style.display = "none";
      }
    }


  },

  async mounted() {
    this.getBeeClientInfo();
    // this.xpNumber = 200;
    // this.animXpNumber();

    this.formatTask(this.testTaskList);
    await this.init();
    await this.getUserLoginInfo();
    await this.getAjaxJsPath();
    //https://b.coderworld.xyz/?state=state&code=WkQzcmdHWUF4YWM4amZFb3NmM1pxajVRZ1p1WHE2b1FMa2gza0JEUzFaakZzOjE3MjQ3Mjk3ODU5MzU6MTowOmFjOjE

    this.initCheckinTasks();
    let href = window.location.href;

    const twitterInfoValue = this.getQueryString(href);
    // let twitterState = twitterInfoValue.state;
    // let twitterCode = twitterInfoValue.code;
    // console.log(twitterState + "=====twitterState")
    // console.log(twitterCode + "=====twitterCode")
    // if (twitterCode != undefined && twitterCode != null) {
    //   twitterCode = twitterCode.replace("#/", "");
    //   if (twitterState != null && twitterState != undefined) {
    //     this.bindTwitter(twitterCode, twitter_redirect_uri);
    //   } else {
    //     this.bindDC(twitterCode, twitter_redirect_uri);
    //   }
    // }

    let bInviteCode = twitterInfoValue.bCode;
    if (bInviteCode != undefined && bInviteCode != null && bInviteCode != "") {
      console.log("invite code " + bInviteCode);
      let localInviteCode = localStorage.getItem('inviteCode')
      if (localInviteCode != undefined && localInviteCode != null && localInviteCode != "") {
      } else {
        localStorage.setItem("inviteCode", bInviteCode);
      }

    }


    // window['onTelegramAuth'] = data => {
    //   this.onTelegramAuth(data);
    // }
    // window.addEventListener('message', this.onHandlerWindowMessageTelegramAuth, true);
    resultEmitEvent("dialog_show", (res) => {
      this.$refs.dialogSuccess.showDialog(res);
      // console.log("=======ChangeWalletAddressListener=" + res);
      this.getCheckinTasks();
    });
    resultEmitEvent("verifyTask", (res) => {
      // console.log("=======verifyTask=" + res);
      this.get_wp_task();
      // console.log("=======verifyTask=" + res);
      this.getRankData();
      // console.log("=======verifyTask=" + res);
      this.animXpNumber();
    });

    resultEmitEvent("doCheckin", (res) => {
      // this.initCheckinTasks();
      this.showSignSuccessDialog();
      this.animXpNumber();
    });

    this.signIcon = icon_sign

    this.checkViewDisplay();


  },


}

</script>

<style scoped>
.icon_app_top_img {
  width: 130px;
  height: 120.636px;
  margin-top: -60px;
  background-image: url("https://www.bee.com/wp-content/uploads/2025/02/icon_app_top_img.png");
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.bee_content_main {
  background-image: linear-gradient(201deg, #FFEECD 4.22%, #FEF7F1 73.64%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 16px;
  margin-top: -26px;
  /* padding: 12px; */
  box-sizing: border-box;
  width: 100%;
  max-width: 400px;
}

@media (max-width:767.98px) {
  .bee_content_main {
    background-image: linear-gradient(201deg, #FFEECD 4.22%, #FEF7F1 73.64%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 16px;
    margin-top: -26px;
    /* padding: 12px; */
    box-sizing: border-box;
    width: 100%;
  }
}


.sendBtn {
  font-size: 16px;
  color: #ffffff;
  width: 180px;
  height: 32px;
  border-radius: 8px;
  background-color: #ffc04d;
  background: #ffc04d;
  line-height: 32px;

}

.h_layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.input_css {
  min-height: 32px;
  border: none;
  outline: none;
  border-width: 1px;
  border-color: gray;
  border-radius: 8px;
  min-width: 60%;
}

.bee_task_base_layout {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 16px;
  border-radius: 20px;
  background-image: url("https://www.bee.com/wp-content/uploads/2025/02/icon_app_phone_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.net_layout {
  background: #8b6112;
  border-width: 2px;
  border-color: bisque;
  width: 300px;
  padding: 12px;
  border-radius: 8px;
  color: #fff;
  margin-bottom: 16px;
}



.pageLayout {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}

.imgIcon {
  width: 32px;
  height: 32px;
}

.dialog_app_layout {
  display: flex;
  justify-content: space-between;
  /* align-items: start; */
  flex-direction: row;
  min-width: 320px;
  margin-bottom: 0px;
}

.icon_app_close_img {
  width: 28px;
  height: 28px;
  background-image: url("../assets/icon_close.png");
  background-size: cover;
  background-repeat: no-repeat;
  box-sizing: border-box;
  margin-left: 0px;
  margin-top: -16px;
}

.icon_app_close_empty {
  width: 28px;
  height: 28px;
  transform: rotate(-25deg);
  box-sizing: border-box;
  margin-bottom: 0px;
}

.bar_layout {
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: -webkit-fill-available;
  width: -moz-available;
  align-items: center;
  margin-top: 16px;
  margin-left: 12px;
  margin-right: 12px;
  justify-content: space-between;
}

.sign_css {
  border-radius: 30px;
  background: #FFF;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #F78605;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  /* 142.857% */
  letter-spacing: 0.14px;
}

.sign_logo {
  width: 20px;
  height: 20px;
  margin-right: 4px;
  background-image: url("../assets/icon_sign.png");
  background-size: cover;
  background-repeat: no-repeat;
}


.tab-content {
  display: flex;
  transition: transform 0.5s ease;
  width: -webkit-fill-available;
  width: -moz-available;
}
</style>
